import { useState } from 'react';

export default function CouponPopup({ setLgShow1 }) {
    const [copied, setCopied] = useState(false);
    const couponCode = "TYGHLEDBNJ";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(couponCode).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="box-profile-pop-profile text-center" style={{ padding: "20px" }}>
        <br/>
            <div className="logoutpop">
                <img src="assets/coupon.jpg" className="img-fluid" alt="coupon" />
            </div>

            <div className="logoutpop mt-3" style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                <h5 style={{ fontWeight: "600", color: "#333" }}>You've unlocked a</h5>
                <h2 style={{ color: "#ff4081", fontWeight: "700" }}>₹200 OFF</h2>
                <p style={{ color: "#666" }}>flat discount coupon</p>
            </div>

            <div className="logoutpop mt-3">
                <div
                    style={{
                        background: "#f3f3f3",
                        borderRadius: "8px",
                        padding: "12px 20px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "10px",
                        justifyContent: "center"
                    }}
                >
                    <code style={{ fontSize: "18px", fontWeight: "bold", letterSpacing: "1px" }}>
                        {couponCode}
                    </code>
                    <button
                        onClick={copyToClipboard}
                        style={{
                            background: "#ff4081",
                            border: "none",
                            color: "#fff",
                            padding: "6px 12px",
                            borderRadius: "5px",
                            cursor: "pointer"
                        }}
                    >
                        {copied ? "Copied!" : "Copy"}
                    </button>
                </div>
            </div>

            <div className="logoutpop mt-4">
                <button
                    className="btn btncancellog"
                    style={{
                        background: "#242933",
                        padding: "8px 40px",
                        color: "white",
                        borderRadius: "8px"
                    }}
                    onClick={() => setLgShow1(false)}
                >
                    Okay
                </button>
            </div>
        </div>
    );
}
